<app-modal
  [title]="'Online-Kartenbestellungen' | trans:'online-orders-modal/header/title'"
  maxWidth="1000px"
>
  <ng-template>
    <app-online-orders-search
      [orders]="orders()"
      [status]="status()"
      [pagination]="pagination()"
      [isLoading]="isLoading()"
      (statusChange)="setStatus($event)"
      (searchChange)="setSearch($event)"
      (pageChange)="setPage($event)"
      (refresh)="loadOrders()"
      (detailsRequested)="onlineOrderDetailsModalComponent.open({ transactionId: $event })"
      (fulfilmentRequested)="onlineOrderDetailsModalComponent.startFulfilmentFor($event)"
    />
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        class="button button--md button--primary-ghost text-uppercase"
        (click)="close()"
      >
        {{ 'Schliessen' | trans:'online-orders-modal/close.Button' }}
      </button>
    </div>
  </ng-container>
</app-modal>

<app-online-order-details-modal
  #onlineOrderDetailsModalComponent
  (fulfilmentCompleted)="close()"
/>
